import * as intl from 'react-intl'

import { wrapper } from './wrapper'

// If you start using a new export from react-intl, make sure it's reexported in
// the translation app, javascript/widgetapp/src/apps/translationWrapper/reactIntlWrapper.js
export const FormattedDate = wrapper(intl.FormattedDate)
export const FormattedTime = wrapper(intl.FormattedTime)
export const FormattedRelativeTime = wrapper(intl.FormattedRelativeTime)
export const FormattedNumber = wrapper(intl.FormattedNumber)
export const FormattedNumberParts = wrapper(intl.FormattedNumberParts)
export const FormattedPlural = wrapper(intl.FormattedPlural)
export const FormattedMessage = wrapper(intl.FormattedMessage)

export { formats as intlFormats } from './formats'

export { wrapper as wrapIntlComponent }
